// Distance calculation utilities
export const getDistanceLabel = (employee, taskLocation, employeeLocations) => {
  if (!employee || !taskLocation?.coordinates?.lat || !taskLocation?.coordinates?.lng) {
    return '(location unknown)';
  }
  
  const empLoc = employeeLocations.find(loc => loc.employee && loc.employee.id === employee.id);
  if (!empLoc || !empLoc.location || !empLoc.location.coords) {
    return '(location unknown)';
  }
  
  const lastUpdated = new Date(empLoc.lastUpdated);
  const now = new Date();
  const ageMs = now - lastUpdated;
  
  // If location is older than 24 hours, consider it stale
  if (ageMs > 24 * 60 * 60 * 1000) {
    return '(location unknown)';
  }
  
  const distance = calculateDistance(
    taskLocation.coordinates.lat,
    taskLocation.coordinates.lng,
    empLoc.location.coords.latitude,
    empLoc.location.coords.longitude
  );
  
  return `${distance.toFixed(2)} km away`;
};

// Haversine formula for calculating distance between two points
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => value * Math.PI / 180;
  const R = 6371; // Earth's radius in kilometers
  
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) + 
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * 
            Math.sin(dLon/2) * Math.sin(dLon/2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c;
  
  return distance;
};

export const isLocationStale = (lastUpdated, maxAgeHours = 24) => {
  const now = new Date();
  const past = new Date(lastUpdated);
  const ageMs = now - past;
  return ageMs > maxAgeHours * 60 * 60 * 1000;
}; 